module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/media-library-2-95b4e3374fe52b48f9b1bb627889d8ce.svg";